import { LayoutType } from '../types';
export const isLeftAlignedLayout = layoutType => {
  return [LayoutType.LeftAlignedTwoColumn, LayoutType.LeftAligned].includes(layoutType);
};